import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";


import { Badge, Card, Col, Flex, message, Modal, Tag } from "antd";
import { Alert } from "components/elements";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import * as services from "../services/employeeApi";
import {
  setCalendar,
  setIsLoading
} from "../slices/employeeSlice";
import styles from "../styles/EmployeeWorkinCalendar.module.css";
import { t } from "i18next";
import { setCalendarEndDate, setCalendarStartDate } from "features/myTeam/slices/myteamSlice";
import { dataURLtoFile, generateRandomString } from "utils/helper";
import { setCurrentCompanyProfile } from "features/company/slices/companySlice";

function useEmployeeWorkInCalendar() {
  const dispatch = useDispatch();
  const params = useParams();

  const { isLoading, calendar, calendarStartDate, calendarEndDate } = useSelector((state) => state.employee);
  const { currentCompany, currentEmployee } = useSelector((state) => state.company);
  const { id: employeeId } = params;
  const [employeeTeam, setEmployeeTeam] = useState()
  const { i18n } = useTranslation()
  const [renderType, setRenderType] = useState()
  const [year, setYear] = useState(dayjs().year())
  const [startDate, setStartDate] = useState(calendarStartDate || dayjs().startOf('month').format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(calendarEndDate || dayjs().endOf('month').format("YYYY-MM-DD"));
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [offSiteOptions, setOffSiteOptions] = useState([]);
  const [leaveGroupOptions, setLeaveGroupOptions] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLeaveDetailModalOpen, setIsLeaveDetailModalOpen] = useState(false);
  const [previousFile, setpreviousFilew] = useState(null);
  const [files, setFiles] = useState([]);

  const formatTime = (timeString) => {
    if (!timeString) return "Invalid Time";

    let time;

    if (timeString.includes('T')) {
      time = dayjs(timeString);
    } else {
      time = dayjs(`1970-01-01T${timeString}`);
    }

    return time.isValid() ? time.format("HH:mm") : "Invalid Time";
  };

  const getCalendarRange = (date) => {
    const firstDayOfMonth = dayjs(date).startOf('month');
    const lastDayOfMonth = dayjs(date).endOf('month');

    const firstDayOfWeek = firstDayOfMonth.day();
    const calendarStart = firstDayOfWeek === 0
      ? firstDayOfMonth
      : firstDayOfMonth.subtract(firstDayOfWeek, 'day');

    const lastDayOfWeek = lastDayOfMonth.day();
    const daysToSaturday = lastDayOfWeek === 6
      ? 0
      : 6 - lastDayOfWeek;
    const calendarEnd = lastDayOfMonth.add(daysToSaturday, 'day');

    return {
      start: calendarStart.format("YYYY-MM-DD"),
      end: calendarEnd.format("YYYY-MM-DD")
    };
  };

  useEffect(() => {
    setStartDate(calendarStartDate || dayjs().startOf('month').format("YYYY-MM-DD"));
    setEndDate(calendarEndDate || dayjs().endOf('month').format("YYYY-MM-DD"));
  }, [calendarStartDate, calendarEndDate]);

  const onChange = useCallback((values, employeeTeam) => {
    const range = getCalendarRange(values);

    setYear(values?.$y);

    if (range.start !== startDate || range.end !== endDate) {
      setStartDate(range.start);
      setEndDate(range.end);
      setEmployeeTeam(employeeTeam);

      dispatch(setCalendarStartDate(range.start));
      dispatch(setCalendarEndDate(range.end));
    }
  }, [startDate, endDate, dispatch]);

  const getWorkInCalendar = useCallback(async (startDate, endDate, employeeTeam) => {
    try {
      dispatch(setIsLoading(true))
      const response = await services.getWorkIn({
        employeeId: employeeId ?? employeeTeam ?? currentEmployee,
        companyId: currentCompany,
        year: year,
        startDate: startDate,
        endDate: endDate,
        page: 0,
        size: dayjs(endDate).diff(dayjs(startDate), 'day') + 1
      })
      dispatch(setCalendar(response?.data?.content))
    } catch (error) {
      Alert({ type: "error", resultObject: error });
    } finally {
      dispatch(setIsLoading(false))
    }
  }, [currentCompany, currentEmployee, dispatch, employeeId, year, startDate, endDate])

  useMemo(() => {
    if (calendarStartDate && calendarEndDate) {
      setStartDate(calendarStartDate);
      setEndDate(calendarEndDate);
    } else {
      const range = getCalendarRange(dayjs());
      setStartDate(range.start);
      setEndDate(range.end);

      // อัพเดท Redux state ด้วย
      dispatch(setCalendarStartDate(range.start));
      dispatch(setCalendarEndDate(range.end));
    }
  }, [calendarStartDate, calendarEndDate, dispatch]);

  const getMonthData = (value) => {
    if (value.month() === 8) {
      return 1394;
    }
  };

  function tagByShift(value, text) {
    switch (value) {
      case "กะทำงานปกติ":
        return (
          <Tag color="#E6F3FF" style={{ borderRadius: "4px", width: "max-content" }}><span style={{ color: "#0085FF", fontSize: "14px" }}>{text}</span></Tag>
        )
      case "Normals":
        return (
          <Tag color="#E6F3FF" style={{ borderRadius: "4px", width: "max-content" }}><span style={{ color: "#0085FF", fontSize: "14px" }}>{text}</span></Tag>
        )
      case "กะเช้า":
        return (
          <Tag color="#E6F3FF" style={{ borderRadius: "4px", width: "max-content" }}><span style={{ color: "#0085FF", fontSize: "14px" }}>{text}</span></Tag>
        )
      case "กะเย็น":
        return (
          <Tag color="#E6F3FF" style={{ borderRadius: "4px", width: "max-content" }}><span style={{ color: "#0085FF", fontSize: "14px" }}>{text}</span></Tag>
        )
      case "กะลาหยุด":
        return (
          <Tag color="#E6F3FF" style={{ borderRadius: "4px", width: "max-content" }}><span style={{ color: "#0085FF", fontSize: "14px" }}>{text}</span></Tag>
        )
      default:
        return (<Tag color="#E6F3FF" style={{ borderRadius: "4px", width: "max-content" }}><span style={{ color: "#0085FF", fontSize: "14px" }}>{text}</span></Tag>)
    }
  }

  function tagByStatus(value, text) {
    switch (value) {
      case "วันหยุดตามกะการทำงาน":
        return (
          <Tag color="#E8E8E8" style={{ borderRadius: "4px", width: "max-content" }}><span style={{ color: "#585757", fontSize: "14px" }}>วันหยุดตามกะ</span></Tag>
        )
      case "Day Off":
        return (
          <Tag color="#E8E8E8" style={{ borderRadius: "4px", width: "max-content" }}><span style={{ color: "#585757", fontSize: "14px" }}>{value}</span></Tag>
        )
      case "ลางาน":
        return (
          <Tag color="#E8E8E8" style={{ borderRadius: "4px", width: "max-content" }}><span style={{ color: "#585757", fontSize: "14px" }}>{value}</span></Tag>
        )
      case "Leave":
        return (
          <Tag color="#E8E8E8" style={{ borderRadius: "4px", width: "max-content" }}><span style={{ color: "#585757", fontSize: "14px" }}>{value}</span></Tag>
        )
      case "ขาดงาน":
        return (
          <Tag color="#FFECEC" style={{ borderRadius: "4px", width: "max-content" }}><span style={{ color: "#E92C2C", fontSize: "14px" }}>{value}</span></Tag>
        )
      case "Absent":
        return (
          <Tag color="#FFECEC" style={{ borderRadius: "4px", width: "max-content" }}><span style={{ color: "#E92C2C", fontSize: "14px" }}>{value}</span></Tag>
        )
      case "ออกงานก่อนเวลา":
        return (
          <Tag color="#FFF5E9" style={{ borderRadius: "4px", width: "max-content" }}><span style={{ color: "#FFA726", fontSize: "14px" }}>{text}</span></Tag>
        )
      case "Early":
        return (
          <Tag color="#FFF5E9" style={{ borderRadius: "4px", width: "max-content" }}><span style={{ color: "#FFA726", fontSize: "14px" }}>{text}</span></Tag>
        )
      case "เข้างานสาย":
        return (
          <Tag color="#FFF5E9" style={{ borderRadius: "4px", width: "max-content" }}><span style={{ color: "#FFA726", fontSize: "14px" }}>{text}</span></Tag>
        )
      case "Late":
        return (
          <Tag color="#FFF5E9" style={{ borderRadius: "4px", width: "max-content" }}><span style={{ color: "#FFA726", fontSize: "14px" }}>{text}</span></Tag>
        )
      case "เข้างานสายและออกงานก่อนเวลา":
        return (
          <Tag color="#FFF5E9" style={{ borderRadius: "4px", width: "max-content" }}><span style={{ color: "#FFA726", fontSize: "14px" }}>{text}</span></Tag>
        )
      case "Late And Early":
        return (
          <Tag color="#FFF5E9" style={{ borderRadius: "4px", width: "max-content" }}><span style={{ color: "#FFA726", fontSize: "14px" }}>{text}</span></Tag>
        )
      case "ปกติ":
        return (
          <Tag color="#E6F9EB" style={{ borderRadius: "4px", width: "max-content" }}><span style={{ color: "#00BA34", fontSize: "14px" }}>{text}</span></Tag>
        )
      case "Normal":
        return (
          <Tag color="#E6F9EB" style={{ borderRadius: "4px", width: "max-content" }}><span style={{ color: "#00BA34", fontSize: "14px" }}>{text}</span></Tag>
        )
      default:
        return (<Tag color="processing">{value}</Tag>)
    }
  }

  const statusColor = [
    {
      code: "Normal",
      color: "#00BA34",
      bgColor: "#E6F9EB"
    },
    {
      code: "OVERTIME",
      color: "#6A51C1",
      bgColor: "#E1DCF3"
    },
    {
      code: ["Late", "Late And Early", "Early"],
      color: "#FF9F2D",
      bgColor: "#FFF5E9"
    },
    {
      code: "Absent",
      color: "#E92C2C",
      bgColor: "#FFECEC"
    },
    {
      code: ["Change shifts", "Business Leave", "Maternity Leave", "Sick Leave", "Business Leave (without pay)"],
      color: "#585757",
      bgColor: "#E8E8E8"
    },
    {
      code: "Leave",
      color: "#E74AAB",
      bgColor: "#FADBEE"
    }
  ]

  const shiftColor = [
    {
      name: "กะการทำงาน",
      nameEn: "Work Shift",
      color: "#0085FF",
      bgColor: "#E6F3FF"
    },
    {
      name: "เข้าทำงานปกติ/ปฏิบัติงานนอกสถานที่",
      nameEn: "Normals/Off-site work",
      color: "#00BA34",
      bgColor: "#E6F9EB"
    },
    {
      name: "ทำงานล่วงเวลาในวันหยุด",
      nameEn: "OT on holidays",
      color: "#6A51C1",
      bgColor: "#E1DCF3"
    },
    {
      name: "เข้างานสาย/กลับก่อน",
      nameEn: "Arrive late/leave early",
      color: "#FF9F2D",
      bgColor: "#FFF5E9"
    },
    {
      name: "วันหยุดตามกะ",
      nameEn: "Day Off",
      color: "#585757",
      bgColor: "#E8E8E8"
    },
    {
      name: "ขาดงาน",
      nameEn: "Absent",
      color: "#E92C2C",
      bgColor: "#FFECEC"
    },
    // {
    //   name: "เปลี่ยนกะ/เเลกกะ/สลับกะ",
    //   nameEn: "Change shifts",
    //   color: "#E74AAB",
    //   bgColor: "#FADBEE"
    // },
    {
      name: "คำขอลางาน",
      nameEn: "Leave request",
      color: "#E74AAB",
      bgColor: "#FADBEE"
    },
    {
      name: "คำขอที่รออนุมัติ",
      nameEn: "Pending request",
      color: "#FFBF1A",
      bgColor: "#FFF8E0"
    }
  ]

  const leaveStatuses = ["Leave", "Absent", "Business Leave", "Maternity Leave", "Sick Leave", "Business Leave (without pay)"];

  const monthCellRender = (value) => {
    const num = getMonthData(value);
    return num ? (
      <div className={styles.notesMonth}>
        <section>{num}</section>
        <span>Backlog number</span>
      </div>
    ) : null;
  };

  const dateCellRender = useCallback((value) => {
    const filterDate = calendar?.filter((o) =>
      dayjs(value).format("YYYY-MM-DD") === dayjs(o?.date).format('YYYY-MM-DD')
    )
    return (
      <ul className={styles.events}>
        {
          filterDate?.length > 0 ? (
            filterDate?.map((o) => (
              <li key={o?.date}>
                {o?.status === "วันหยุดตามกะการทำงาน"
                  ? tagByStatus(i18n.language === 'en' ? o?.statusEn : o?.status)
                  : <Flex vertical style={{ gap: "7px" }}>
                    {/* กะการทำงาน */}
                    {tagByShift(i18n.language === 'en' ? o?.shiftNameEn : o?.shiftName, `${formatTime(o?.workInDateStart)} ${t("unit.to")} ${formatTime(o?.workInDateEnd)}`)}

                    {/* status */}

                    {o?.status ? o?.status === "ขาดงาน" && tagByStatus(i18n.language === 'en' ? o?.statusEn : o?.status) : null}
                    {o?.status ? (o?.status !== "ขาดงาน" && o?.status !== "ลางาน") && tagByStatus(i18n.language === "en" ? o?.statusEn : o?.status, `${formatTime(o?.checkInTime)} ${t("unit.to")} ${formatTime(o?.checkOutTime)}`) : null}

                    {o?.status ? o?.status === "ลางาน" && tagByStatus(i18n.language === 'en' ? o?.statusEn : o?.status) : null}
                  </Flex>}

              </li>
            ))
          ) : (
            <div></div>
          )
        }
      </ul>
    );

  }, [calendar]);

  // const cellRender = (current, info) => {
  //   if (info.type === "date") return dateCellRender(current);
  //   if (info.type === "month") return monthCellRender(current);
  //   return info.originNode;
  // };

  const fullCellRender = useCallback(
    (date, info) => {
      const shiftDate = calendar?.find((o) =>
        dayjs(date).format("YYYY-MM-DD") === dayjs(o?.date).format('YYYY-MM-DD')
      );

      const backgroundColor = shiftDate?.status === "วันหยุดตามกะการทำงาน" ? "#f9f9f9" : "#ffffff";

      return (
        <div
          style={{
            minHeight: "15vh",
            padding: "12px",
            backgroundColor: backgroundColor,
            textAlign: "start"
          }}
        >
          <div style={{ marginBottom: "5px", textAlign: "start" }}>{date.format("DD")}</div>
          {dateCellRender(date)}
        </div>
      );
    },
    [dateCellRender]
  );

  const CustomHeader = ({ value, type, onChange, onTypeChange }) => {
    const year = value.year();
    const month = value.month();

    const nextMonth = () => {
      const now = value.clone().month(month + 1);
      onChange(now);
    };

    const prevMonth = () => {
      const now = value.clone().month(month - 1);
      onChange(now);
    };

    return (
      <div style={{ padding: 10 }}>
        <button onClick={prevMonth}>Previous</button>
        <span>{year} - {value.format('MMMM')}</span>
        <button onClick={nextMonth}>Next</button>
      </div>
    );
  };

  const transformCalendar = useMemo(() => {
    return calendar?.flatMap(item => {
      const events = [];
      const leaveCount = Array.isArray(item?.leaveDocument) ? item?.leaveDocument?.length : 0;
      const offSiteCount = item?.offSiteWorkDocument ? 1 : 0;
      const otCount = item?.otDocument ? 1 : 0;
      const totalDocuments = leaveCount + offSiteCount + otCount;

      //กะการทำงานปกติ
      if (item?.shiftName && item?.statusEn?.toLowerCase() !== "day off" && item?.holidayName == null) {
        events.push({
          eventType: "normalShift",
          titleMonth: i18n.language === "en"
            ? `${item?.workInDateStart?.slice(0, 5)} - ${item?.workInDateEnd?.slice(0, 5)}`
            : `${item?.workInDateStart?.slice(0, 5)} ถึง ${item?.workInDateEnd?.slice(0, 5)}`,
          titleDetail: i18n.language === "en" ? item?.shiftNameEn : item?.shiftName,
          start: new Date(item.date),
          end: new Date(item.date),
          workInStart: item.workInDateStart,
          workInEnd: item.workInDateEnd,
          otTimeStart: item.otTimeStart,
          otTimeEnd: item.otTimeEnd,
          otDocumentList: item?.otDocumentList,
          shiftName: item?.shiftName,
          dynamicAllDay: true
        });
      }
      //วันหยุดตามกะ
      else if (item?.statusEn?.toLowerCase() == "day off") {
        events.push({
          eventType: "dayOff",
          titleMonth: i18n.language === "en" ? item?.statusEn : item?.status,
          titleDetail: i18n.language === "en" ? item?.statusEn : item?.status,
          start: new Date(item.date),
          end: new Date(item.date),
          workInStart: item.workInDateStart,
          workInEnd: item.workInDateEnd,
          otTimeStart: item.otTimeStart,
          otTimeEnd: item.otTimeEnd,
          otDocumentList: item?.otDocumentList,
          shiftName: item?.shiftName,
          dynamicAllDay: true
        })
      }
      //วันหยุดตามปฏิทิน
      else if (item?.holidayName !== null) {
        events.push({
          eventType: "holiday",
          titleMonth: i18n.language === "en" ? item?.holidayNameEn : item?.holidayName,
          titleDetail: i18n.language === "en" ? item?.holidayNameEn : item?.holidayName,
          start: new Date(item.date),
          end: new Date(item.date),
          workInStart: item.workInDateStart,
          workInEnd: item.workInDateEnd,
          otTimeStart: item.otTimeStart,
          otTimeEnd: item.otTimeEnd,
          otDocumentList: item?.otDocumentList,
          shiftName: item?.shiftName,
          dynamicAllDay: true
        })
      }

      //Check-in / Check-out
      // ทำงานปกติ
      if (item?.statusEn?.toLowerCase() == "normal") {
        events.push({
          eventType: "normal",
          titleMonth: i18n.language === "en"
            ? `${item?.checkInTime?.slice(11, 16)} - ${item?.checkOutTime ? item?.checkOutTime?.slice(11, 16) : "Absent"}`
            : `${item?.checkInTime?.slice(11, 16)} ถึง ${item?.checkOutTime ? item?.checkOutTime?.slice(11, 16) : "ขาดงาน"}`,
          titleDetail: i18n.language === "en" ? item?.statusEn : item?.status,
          start: new Date(item.date),
          end: new Date(item.date),
          actualCheckIn: item?.checkInTime,
          actualCheckOut: item?.checkOutTime || `${item.date}T23:59:59`,
          shiftName: item?.shiftName,
          statusEn: item?.statusEn,
          leaveDocument: item?.leaveDocument,
          dynamicAllDay: true
        });
      }
      // เข้างานสาย
      else if (item?.statusEn?.toLowerCase() == "late" || item?.statusEn?.toLowerCase() == "late and early" || item?.statusEn?.toLowerCase() == "early") {
        events.push({
          eventType: "lateOrEarly",
          titleMonth: i18n.language === "en"
            ? `${item?.checkInTime?.slice(11, 16)} - ${item?.checkOutTime ? item?.checkOutTime?.slice(11, 16) : "Absent"}`
            : `${item?.checkInTime?.slice(11, 16)} ถึง ${item?.checkOutTime ? item?.checkOutTime?.slice(11, 16) : "ขาดงาน"}`,
          titleDetail: i18n.language === "en" ? item?.statusEn : item?.status,
          start: new Date(item.date),
          end: new Date(item.date),
          actualCheckIn: item?.checkInTime,
          actualCheckOut: item?.checkOutTime || `${item.date}T23:59:59`,
          shiftName: item?.shiftName,
          statusEn: item?.statusEn,
          leaveDocument: item?.leaveDocument,
          dynamicAllDay: true
        });
      }
      // ขาดงาน
      else if (item?.statusEn?.toLowerCase() == "absent") {
        events.push({
          eventType: "absent",
          titleMonth: item?.checkInTime
            ? `${item?.checkInTime?.slice(11, 16)} ${i18n.language === "en" ? "- Absent" : "ถึง ขาดงาน"}`
            : i18n.language === "en" ? item?.statusEn : item?.status,
          titleDetail: item?.checkInTime
            ? `${item?.checkInTime?.slice(11, 16)} ${i18n.language === "en" ? "- Absent" : "ถึง ขาดงาน"}`
            : i18n.language === "en" ? item?.statusEn : item?.status,
          start: new Date(item.date),
          end: new Date(item.date),
          actualCheckIn: item?.checkInTime,
          actualCheckOut: item?.checkOutTime || `${item.date}T23:59:59`,
          shiftName: item?.shiftName,
          statusEn: item?.statusEn,
          leaveDocument: item?.leaveDocument,
          dynamicAllDay: true
        });
      }

      let displayedDocuments = 0;
      const MAX_VISIBLE_DOCUMENTS = 1;

      if (item?.leaveDocument !== null && item?.leaveDocument?.length > 0) {
        if (displayedDocuments < MAX_VISIBLE_DOCUMENTS) {
          events.push({
            eventType: "leave",
            titleMonth: i18n.language === "en" ? item?.leaveDocument?.[0]?.leaveTypeNameEn : item?.leaveDocument?.[0]?.leaveTypeName,
            titleDetail: i18n.language === "en" ? item?.leaveDocument?.[0]?.leaveTypeNameEn : item?.leaveDocument?.[0]?.leaveTypeName,
            start: new Date(item.date),
            end: new Date(item.date),
            leaveDocument: item?.leaveDocument,
            dynamicAllDay: true
          });
          displayedDocuments++;
        }
      }
      else if (item?.leaveDocumentPending !== null && item?.leaveDocumentPending?.length > 0) {
        if (displayedDocuments < MAX_VISIBLE_DOCUMENTS) {
          events.push({
            eventType: "leavePending",
            titleMonth: i18n.language === "en" ? item?.leaveDocumentPending?.[0]?.leaveTypeNameEn : item?.leaveDocumentPending?.[0]?.leaveTypeName,
            titleDetail: i18n.language === "en" ? item?.leaveDocumentPending?.[0]?.leaveTypeNameEn : item?.leaveDocumentPending?.[0]?.leaveTypeName,
            start: new Date(item.date),
            end: new Date(item.date),
            leaveDocumentPending: item?.leaveDocumentPending,
            dynamicAllDay: true
          });
          displayedDocuments++;
        }
      }
      else if (item?.ot && item?.otDocument) {
        if (displayedDocuments < MAX_VISIBLE_DOCUMENTS) {
          if (item?.otDocument?.approveStatus == "APPROVED") {
            events.push({
              eventType: "overtime",
              titleMonth: i18n.language === "en"
                ? `OT : ${item?.otDocument?.startTime?.slice(0, 5)} - ${item?.otDocument?.endTime?.slice(0, 5)}`
                : `OT : ${item?.otDocument?.startTime?.slice(0, 5)} ถึง ${item?.otDocument?.endTime?.slice(0, 5)}`,
              titleDetail: item?.ot,
              start: new Date(item.date),
              end: new Date(item.date),
              otDocument: item?.otDocument,
              otDocumentList: item?.otDocumentList,
              dynamicAllDay: true
            });
            displayedDocuments++;
          } else if (item?.otDocument?.approveStatus == "PENDING") {
            events.push({
              eventType: "overtimePending",
              titleMonth: i18n.language === "en"
                ? `OT : ${item?.otDocument?.startTime?.slice(0, 5)} - ${item?.otDocument?.endTime?.slice(0, 5)}`
                : `OT : ${item?.otDocument?.startTime?.slice(0, 5)} ถึง ${item?.otDocument?.endTime?.slice(0, 5)}`,
              titleDetail: item?.ot,
              start: new Date(item.date),
              end: new Date(item.date),
              otDocument: item?.otDocument,
              otDocumentList: item?.otDocumentList,
              dynamicAllDay: true
            });
            displayedDocuments++;
          }
        }
      }

      else if (item?.offSiteWorkDocument && typeof item?.offSiteWorkDocument === 'object') {
        if (displayedDocuments < MAX_VISIBLE_DOCUMENTS) {
          events.push({
            eventType: "offsite",
            titleMonth: i18n.language === "en"
              ? item?.offSiteWorkDocument?.offSiteWorkGroupEn
              : item?.offSiteWorkDocument?.offSiteWorkGroup,
            titleDetail: i18n.language === "en"
              ? item?.offSiteWorkDocument?.offSiteWorkGroupEn
              : item?.offSiteWorkDocument?.offSiteWorkGroup,
            start: new Date(item.date),
            end: new Date(item.date),
            offSiteDocument: item?.offSiteWorkDocument,
            dynamicAllDay: true
          });
          displayedDocuments++;
        }
      }

      else if (item?.offSiteWorkDocumentPending && typeof item?.offSiteWorkDocumentPending === 'object') {
        if (displayedDocuments < MAX_VISIBLE_DOCUMENTS) {
          events.push({
            eventType: "offsitePending",
            titleMonth: i18n.language === "en"
              ? item?.offSiteWorkDocumentPending?.offSiteWorkGroupEn
              : item?.offSiteWorkDocumentPending?.offSiteWorkGroup,
            titleDetail: i18n.language === "en"
              ? item?.offSiteWorkDocumentPending?.offSiteWorkGroupEn
              : item?.offSiteWorkDocumentPending?.offSiteWorkGroup,
            start: new Date(item.date),
            end: new Date(item.date),
            offSiteWorkDocumentPending: item?.offSiteWorkDocumentPending,
            dynamicAllDay: true
          });
          displayedDocuments++;
        }
      }

      if (totalDocuments > MAX_VISIBLE_DOCUMENTS) {
        const remainingCount = totalDocuments - MAX_VISIBLE_DOCUMENTS;
        events.push({
          eventType: "seeMore",
          titleMonth: `+${remainingCount} ${t("more")}`,
          titleDetail: `+${remainingCount} ${t("more")}`,
          start: new Date(item.date),
          end: new Date(item.date),
          dynamicAllDay: true,
          remainingCount: remainingCount,
          allDocuments: {
            leaveDocument: item?.leaveDocument,
            leaveDocumentPending: item?.leaveDocumentPending,
            otDocument: item?.otDocument,
            offSiteWorkDocument: item?.offSiteWorkDocument,
            offSiteWorkDocumentPending: item?.offSiteWorkDocumentPending
          }
        })
      }

      return events;
    });
  }, [calendar, i18n.language]);

  const requestList = (item, i18n) => {
    const result = [];

    if (Array.isArray(item?.leaveDocument) && item.leaveDocument.length > 0) {
      item.leaveDocument.forEach((doc, index) => {
        result.push({
          id: `leave-${item.date}-${index}-${doc.leaveDocumentId ?? doc.sequence ?? index}`,
          type: "leave",
          rawType: "leaveDocument",
          date: item.date,
          title: i18n.language === "en" ? doc.leaveTypeNameEn : doc.leaveTypeName,
          requestId: doc.documentNo,
          requestStatus: doc.approveStatus,
          employeeName: doc.employeeName || item.employeeName,
          startTime: doc.startTime,
          endTime: doc.endTime,
          remark: doc.remark,
          source: doc,
        });
      });
    }

    if (Array.isArray(item?.leaveDocumentPending) && item.leaveDocumentPending.length > 0) {
      item.leaveDocumentPending.forEach((doc, index) => {
        result.push({
          id: `leavePending-${item.date}-${index}-${doc.leaveDocumentId ?? doc.sequence ?? index}`,
          type: "leavePending",
          rawType: "leaveDocumentPending",
          date: item.date,
          title: i18n.language === "en" ? doc.leaveTypeNameEn : doc.leaveTypeName,
          requestId: doc.documentNo,
          requestStatus: doc.approveStatus,
          employeeName: doc.employeeName || item.employeeName,
          startTime: doc.startTime,
          endTime: doc.endTime,
          remark: doc.remark,
          source: doc,
        });
      });
    }

    if (item?.ot && item?.otDocument) {
      const doc = item.otDocument;
      const type = doc.approveStatus === "APPROVED" ? "overtime" : "overtimePending";

      result.push({
        id: `ot-${item.date}-${doc.otDocumentId ?? doc.sequence ?? 0}`,
        type,
        rawType: "otDocument",
        date: item.date,
        title: i18n.language === "en"
          ? `OT : ${doc.startTime?.slice(0, 5)} - ${doc.endTime?.slice(0, 5)}`
          : `OT : ${doc.startTime?.slice(0, 5)} ถึง ${doc.endTime?.slice(0, 5)}`,
        requestId: doc.documentNo,
        requestStatus: doc.approveStatus,
        employeeName: doc.employeeName || item.employeeName,
        startTime: doc.startTime,
        endTime: doc.endTime,
        remark: doc.remark,
        source: doc,
      });
    }

    if (item?.offSiteWorkDocument && typeof item.offSiteWorkDocument === "object") {
      const doc = item.offSiteWorkDocument;
      result.push({
        id: `offsite-${item.date}-${doc.offSiteWorkDocumentId ?? doc.sequence ?? 0}`,
        type: "offsite",
        rawType: "offSiteWorkDocument",
        date: item.date,
        title: i18n.language === "en" ? doc.offSiteWorkGroupEn : doc.offSiteWorkGroup,
        requestId: doc.documentNo,
        requestStatus: doc.approveStatus,
        employeeName: doc.employeeName || item.employeeName,
        startTime: doc.startTime,
        endTime: doc.endTime,
        remark: doc.remark,
        source: doc,
      });
    }

    if (item?.offSiteWorkDocumentPending && typeof item.offSiteWorkDocumentPending === "object") {
      const doc = item.offSiteWorkDocumentPending;
      result.push({
        id: `offsitePending-${item.date}-${doc.offSiteWorkDocumentId ?? doc.sequence ?? 0}`,
        type: "offsitePending",
        rawType: "offSiteWorkDocumentPending",
        date: item.date,
        title: i18n.language === "en" ? doc.offSiteWorkGroupEn : doc.offSiteWorkGroup,
        requestId: doc.documentNo,
        requestStatus: doc.approveStatus,
        employeeName: doc.employeeName || item.employeeName,
        startTime: doc.startTime,
        endTime: doc.endTime,
        remark: doc.remark,
        source: doc,
      });
    }

    return result;
  };

  function footerTag() {
    return (
      <Flex vertical gap={16} style={{ marginTop: "24px", marginBottom: "16px" }}>
        <Flex gap={8} style={{ alignItems: "center", flexWrap: "wrap" }}>
          {shiftColor.slice(0, 4).map((shift, index) => (
            <Col span={[0].includes(index) ? 4 : [1].includes(index) ? 7 : 5}>
              <Flex key={index} gap={8} style={{ alignItems: "center" }}>
                <div
                  style={{
                    backgroundColor: shift.color,
                    width: "15px",
                    height: "15px",
                    borderRadius: "50%",
                  }}
                />
                <Tag
                  color={shift.bgColor}
                  style={{ borderRadius: "4px", width: "max-content" }}
                >
                  <span style={{ color: shift.color }}>
                    {i18n.language === "en" ? shift.nameEn : shift.name}
                  </span>
                </Tag>
              </Flex>
            </Col>
          ))}
        </Flex>

        <Flex gap={8} style={{ alignItems: "center", flexWrap: "wrap" }}>
          {shiftColor.slice(4, 8).map((shift, index) => (
            <Col span={[0].includes(index) ? 4 : [1].includes(index) ? 7 : 5}>
              <Flex key={index} gap={8} style={{ alignItems: "center" }}>
                <div
                  style={{
                    backgroundColor: shift.color,
                    width: "15px",
                    height: "15px",
                    borderRadius: "50%",
                  }}
                />
                <Tag
                  color={shift.bgColor}
                  style={{ borderRadius: "4px", width: "max-content" }}
                >
                  <span style={{ color: shift.color }}>
                    {i18n.language === "en" ? shift.nameEn : shift.name}
                  </span>
                </Tag>
              </Flex>
            </Col>
          ))}
        </Flex>
      </Flex>
    )
  }

  useEffect(() => {
    if (currentCompany && employeeId) {
      getWorkInCalendar(startDate, endDate)
    }
  }, [currentCompany, startDate, endDate, employeeId, employeeTeam, getWorkInCalendar])

  // useMemo(() => {
  //   getWorkInCalendar(startDate, endDate)
  // }, [startDate, endDate])

  const onAttachFileChange = async ({
    attachFile,
    setFieldValue,
    setImageUrl,
    setFileName,
    initialValuesImageUrl,
    initialValuesFileName,
    initialValuesFileType,
    initialValuesFileList,
    setInitialValuesFileName,
    setInitialValuesFileType,
    setInitialValuesImageUrl,
    setInitialValuesFileList
  }) => {
    const fileUrls = [...initialValuesImageUrl];
    const fileNames = [...initialValuesFileName];
    const fileList = [...initialValuesFileList];
    const fileTypes = [...initialValuesFileType];
    const attachFileList = attachFile?.file;

    try {
      const allowedTypes = ["image/png", "image/jpeg", "application/pdf", "application/vnd.ms-excel"];
      const fileType = attachFileList?.type;
      const fileSize = attachFileList?.size;

      fileTypes.push(fileType)

      if (!allowedTypes.includes(fileType)) {
        Modal.error({
          title: "File Upload Error",
          content: "Unsupported file type. Only PNG, JPEG, XLS, and PDF are allowed.",
          okText: "Close",
          okButtonProps: { style: { height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", boxShadow: "none" } },
        });
        return;
      }

      if (fileType === "application/pdf" || fileType === "application/vnd.ms-excel") {
        const base64 = await new Promise((resolve) => {
          const reader = new FileReader();
          reader.readAsDataURL(attachFileList?.originFileObj);
          reader.onload = () => resolve(reader.result);
        });

        const filename = `${Date.now()}_${attachFileList?.name}`;
        const file = dataURLtoFile(base64, filename);
        fileUrls.push(base64)
        fileNames.push(filename)
        fileList.push(file)
      } else {
        const compressImg = await services.compressedImage({
          file: attachFileList?.originFileObj,
        });

        const base64 = await new Promise((resolve) => {
          const reader = new FileReader();
          reader.readAsDataURL(compressImg.data);
          reader.onload = () => resolve(reader.result);
        });

        const filename = `${Date.now()}_${attachFileList?.name}`;
        const file = dataURLtoFile(base64, filename);

        fileUrls.push(base64)
        fileNames.push(filename)
        fileList.push(file)
      }
    } catch (error) {
      Modal.error({
        title: "File Upload Error",
        content: error.message,
        okText: "Close",
        okButtonProps: { style: { height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", boxShadow: "none" } },
      });
      // setIsProcessing(false);
      return;
    }

    setpreviousFilew(attachFileList);
    setFiles(fileList);
    setFileName(fileNames);
    setInitialValuesFileName(fileNames);
    setInitialValuesFileType(fileTypes);
    setInitialValuesImageUrl(fileUrls);
    setInitialValuesFileList(fileList);
    setFieldValue("attachFile", fileList);
    setFieldValue("attachFileType", fileTypes);
    setFieldValue("attachFileName", fileNames);
    setImageUrl(fileUrls);

  };

  const modifiedOffSiteOptions = useMemo(() => {
    return offSiteOptions?.map((opt) => ({
      ...opt,
      label: i18n.language === "en" ? opt?.nameEn : opt?.name,
      value: opt?.id,
    }));
  }, [i18n.language, offSiteOptions]);

  const modifiedLeaveGroupOptions = useMemo(() => {
    return leaveGroupOptions?.map((opt) => ({

      ...opt,
      unlimited: opt?.unlimited ? opt?.unlimited : 'N',
      emergencyFlag: opt?.emergencyFlag ? opt?.emergencyFlag : 'N',
      emergencyUsed: opt?.emergencyUsed ? opt?.emergencyUsed : 0,
      remainingLeaveDays: opt?.remainingLeaveDays,
      remainingLeaveHour: opt?.remainingLeaveHour,
      label: i18n === "en" ? opt?.leaveTypeNameEn : opt?.leaveTypeName,
      value: opt?.leaveId,
    }));
  }, [i18n, leaveGroupOptions]);

  const getOffSiteOptions = useCallback(async (empTeam) => {
    if (typeof currentCompany !== "object") {
      try {
        dispatch(setIsLoading(true));
        const values = {
          requestId: generateRandomString(),
          companyId: currentCompany,
          employeeId: employeeId ?? empTeam ?? employeeTeam ?? currentEmployee,
        };
        const response = await services.getLeaveGroupIsOffSite(
          values
        );
        setOffSiteOptions(response.data);
      } catch (error) {
        Alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    }
  }, [currentCompany, currentEmployee, employeeTeam, dispatch]);

  const getLeaveGroupOptions = useCallback(async (empTeam) => {

    if (typeof currentCompany !== "object") {
      try {
        dispatch(setIsLoading(true));
        const values = {
          requestId: generateRandomString(),
          companyId: currentCompany,
          employeeId: employeeId ?? empTeam ?? employeeTeam ?? currentEmployee,
        };
        const response = await services.getLeaveGroupIsLeave(values);
        setLeaveGroupOptions(response.data);
      } catch (error) {
        Alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    }
  }, [currentCompany, currentEmployee, employeeTeam, dispatch]);

  const onSubmitSupRequest = useCallback(async (params) => {
    const targetEmployeeId = employeeId ?? params?.employeeId ?? currentEmployee;

    Modal.confirm({
      title: t("dialog.confirmation.header"),
      content: (
        i18n.language === "en"
          ? "Are you sure you want to submit OT request ?"
          : "คุณยืนยันการยื่นคำขอทำงานล่วงเวลาใช่หรือไม่ ?"
      ),
      okText: t("common.confirm"),
      cancelText: t("common.cancel"),
      async onOk() {
        try {
          dispatch(setIsLoading(true))
          const response = await services.createSupervisorOtRequest({
            ...params,
            requestId: generateRandomString(),
            companyId: currentCompany,
            employeeId: targetEmployeeId,
            startDate: params.startDate
              ? dayjs(params.startDate).format("YYYY-MM-DD")
              : undefined,
            startTime: params.startTime
              ? dayjs(params.startTime).format("HH:mm:ss")
              : undefined,
            endTime: params.endTime
              ? dayjs(params.endTime).format("HH:mm:ss")
              : undefined,
            supervisorRequest: "Y",
            sendingType: "SUBMIT"
          });

          if (response?.data?.content?.code === "200") {
            message.success(t("common.success"))
            return;
          }

          if (response?.data?.content?.code === "400") {
            Modal.error({
              content: response?.data?.content?.details?.[0]?.value,
              okText: t("message.ok"),
            });
            return;
          }

        } catch (error) {

        } finally {
          dispatch(setIsLoading(false));
          getWorkInCalendar(startDate, endDate, targetEmployeeId);
        }
      }
    })
  }, [currentCompany, currentEmployee, dispatch, employeeId, endDate, getWorkInCalendar, startDate])

  const onSubmitOffSiteWork = useCallback(async (params) => {
    const targetEmployeeId = employeeId ?? params?.employeeId ?? currentEmployee;

    Modal.confirm({
      title: t("dialog.confirmation.header"),
      content: (
        i18n.language === "en"
          ? "Are you sure you want to submit off-site work request ?"
          : "คุณยืนยันการยื่นคำขอปฏิบัติงานนอกสถานที่ใช่หรือไม่ ?"
      ),
      okText: t("common.confirm"),
      cancelText: t("common.cancel"),
      async onOk() {
        try {
          dispatch(setIsLoading(true))
          const response = await services.createOffsiteWorkRequest({
            ...params,
            requestId: generateRandomString(),
            companyId: currentCompany,
            employeeId: targetEmployeeId,
            startDate: params.startDate
              ? dayjs(params.startDate).format("YYYY-MM-DD")
              : null,
            endDate: params.endDate
              ? dayjs(params.endDate).format("YYYY-MM-DD")
              : null,
            startTime: params.startTime
              ? dayjs(params.startTime).format("HH:mm:ss")
              : "00:00:00",
            endTime: params.endTime
              ? dayjs(params.endTime).format("HH:mm:ss")
              : "00:00:00",
            supervisorRequest: "Y",
            sendingType: "SUBMIT"
          });

          if (response?.data?.content?.code === "200") {
            message.success(t("common.success"))
            return;
          }

          if (response?.data?.content?.code === "400") {
            Modal.error({
              content: response?.data?.content?.details?.[0]?.value,
              okText: t("message.ok"),
            });
            return;
          }

        } catch (error) {

        } finally {
          dispatch(setIsLoading(false));
          getWorkInCalendar(startDate, endDate, targetEmployeeId);
        }
      }
    })

  }, [currentCompany, currentEmployee, dispatch, employeeId, endDate, getWorkInCalendar, startDate])

  const onSubmitLeave = useCallback(async (params) => {
    const targetEmployeeId = employeeId ?? params?.employeeId ?? currentEmployee;

    Modal.confirm({
      title: t("dialog.confirmation.header"),
      content: (
        i18n.language === "en"
          ? "Are you sure you want to submit leave request ?"
          : "คุณยืนยันการยื่นคำขอลาใช่หรือไม่ ?"
      ),
      okText: t("common.confirm"),
      cancelText: t("common.cancel"),
      async onOk() {
        try {
          dispatch(setIsLoading(true));
          const response = await services.createLeaveRequest({
            ...params,
            requestId: generateRandomString(),
            companyId: currentCompany,
            employeeId: targetEmployeeId,
            startDate: params.startDate
              ? dayjs(params.startDate).format("YYYY-MM-DD")
              : null,
            endDate: params.endDate
              ? dayjs(params.endDate).format("YYYY-MM-DD")
              : null,
            startTime: params.startTime
              ? dayjs(params.startTime).format("HH:mm:ss")
              : "00:00:00",
            endTime: params.endTime
              ? dayjs(params.endTime).format("HH:mm:ss")
              : "00:00:00",
            supervisorRequest: "Y",
            sendingType: "SUBMIT"
          });

          if (response?.data?.content?.code === "200") {
            message.success(t("common.success"))
            return;
          }

          if (response?.data?.content?.code === "400") {
            Modal.error({
              content: response?.data?.content?.details?.[0]?.value,
              okText: t("message.ok"),
            });
            return;
          }

        } catch (error) {
        } finally {
          dispatch(setIsLoading(false));
          getWorkInCalendar(startDate, endDate, targetEmployeeId);
        }
      }
    });
  }, [currentCompany, currentEmployee, dispatch, employeeId, endDate, getWorkInCalendar, startDate])

  const getCompany = useCallback(async () => {
    try {
      dispatch(setIsLoading(true));
      if (currentCompany) {
        const response = await services.getCompany({
          requestId: generateRandomString(),
          companyId: currentCompany,
        });
        dispatch(setCurrentCompanyProfile(response.data));
      }
    } catch (error) {
      // alert({ type: "error", resultObject: error });
    } finally {
      dispatch(setIsLoading(false));
    }
  }, [currentCompany, dispatch]);

  const onSubmitEditWorkTime = useCallback(async (params) => {
    const targetEmployeeId = employeeId ?? params?.employeeId ?? currentEmployee;

    Modal.confirm({
      title: t("dialog.confirmation.header"),
      content: (
        i18n.language === "en"
          ? "Are you sure you want to edit work time ?"
          : "คุณยืนยันการแก้ไขเวลาทำงานใช่หรือไม่ ?"
      ),
      okText: t("common.confirm"),
      cancelText: t("common.cancel"),
      async onOk() {
        try {
          dispatch(setIsLoading(true));
          const response = await services.txnTimeAttendanceEdit({
            employeeId: targetEmployeeId,
            startDate: params?.editDate?.format("YYYY-MM-DD"),
            startDateTime: params?.startTime?.format("HH:mm:ss"),
            endDateTime: params?.endTime?.format("HH:mm:ss")
          });

          if (response?.data?.status?.code === "200") {
            message.success(t("common.success"));
            return;
          }

          if (response?.data?.content?.code === "400") {
            Modal.error({
              content: response?.data?.content?.details?.[0]?.value,
              okText: t("message.ok"),
            });
            return;
          }

        } catch (error) {
        } finally {
          dispatch(setIsLoading(false));
          getWorkInCalendar(startDate, endDate, targetEmployeeId);
        }
      }
    });
  }, [currentEmployee, dispatch, employeeId, endDate, getWorkInCalendar, startDate]);

  useEffect(() => {
    if (currentCompany && typeof currentCompany !== "object") {
      getCompany();
    }
  }, [currentCompany, getCompany]);

  useEffect(() => {
    if (isModalOpen) {
      getOffSiteOptions();
      getLeaveGroupOptions();
    }
  }, [getOffSiteOptions, isModalOpen])

  return {
    isLoading,
    isModalOpen,
    calendar,
    getWorkInCalendar,
    cellRender: fullCellRender,
    onChange,
    CustomHeader,
    footerTag,
    transformCalendar,
    statusColor,
    isUpdateMode,
    setIsUpdateMode,
    onSubmitSupRequest,
    setIsModalOpen,
    employeeTeam,
    workTypeOptions: modifiedOffSiteOptions,
    onAttachFileChange,
    setpreviousFilew,
    onSubmitOffSiteWork,
    leaveGroupOptions: modifiedLeaveGroupOptions,
    onSubmitLeave,
    onSubmitEditWorkTime,
    setIsLeaveDetailModalOpen,
    isLeaveDetailModalOpen,
    requestList,
    setEmployeeTeam,
    getCalendarRange
    // editTimeAtt
  };
}

export default useEmployeeWorkInCalendar;
